import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import ThemeManager from "./ThemeManager"

const SiteThemeHome = () => {
  return (
    <SidePanelLayout
      menuName="AdminSiteThemesMenu"
      tabs={{
        themes: ThemeManager,
      }}
    />
  )
}

export default SiteThemeHome